'use client';

import { ReactComponent as GoogleLogo } from '@findy-code/yuffie/shared/images/google-logo.svg';
import { gaSendEvent } from '@findy-code/yuffie/utils/events/event';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { FaGithub } from 'react-icons/fa';

import styles from './login-banner.component.module.scss';

/**
 * 非ログイン時にページ下部に表示するログインボタンバナー
 */
export const LoginBannerComponent = () => {
  const pathname = usePathname() ?? '';
  const searchParams = useSearchParams();
  const redirectPath =
    searchParams?.toString().length ?? 0 > 0
      ? `${pathname}?${searchParams?.toString()}`
      : pathname;

  return (
    <div className={styles.loginBanner}>
      <div className={styles.loginBannerButtonLinksWrapper}>
        <Link
          className={styles.loginBannerButtonLink}
          data-theme="github"
          href={{ pathname: '/users/sign_in', query: { r: redirectPath } }}
          onClick={() => {
            gaSendEvent({
              category: 'link',
              action: 'click',
              label: '求人計測_Github_CVクリック',
            });
            gaSendEvent({
              category: 'register',
              action: 'click',
              label: 'github',
            });
          }}
        >
          <FaGithub aria-hidden="true" size="18px" />
          GitHubで新規登録/ログイン
        </Link>
        <Link
          className={styles.loginBannerButtonLink}
          data-theme="google"
          href={{ pathname: '/users/sign_in', query: { r: redirectPath } }}
          onClick={() => {
            gaSendEvent({
              category: 'link',
              action: 'click',
              label: '求人計測_Google_CVクリック',
            });
          }}
        >
          <GoogleLogo aria-hidden="true" style={{ width: '18px' }} />
          Googleで新規登録/ログイン
        </Link>
      </div>
      <div className={styles.loginBannerTermsWrapper}>
        <Link href="/terms">利用規約</Link>、
        <Link href="https://findy.co.jp/privacy">プライバシーポリシー</Link>
        に同意の上サービスをご利用ください。
      </div>
    </div>
  );
};
